import { useState, useEffect } from 'react';

const Toggle = ({value, onChange, label, id, readOnly}) => {
  return (
    <div className="flex f-start f-row gap-10 grow-0">
      <label style={{ marginBottom: '0px' }} className="flex-label" htmlFor={id}>{label}</label>
      <label className="switch mb-0 ml-auto">
          <input type="checkbox" id={id} readOnly={readOnly} onChange={onChange} checked={value} />
          <span className="slider round"></span>
      </label>
  </div>
  )
};

export default Toggle;